import React from 'react'
import CollectorsRowData from '../Collectors/CollectorsRowData'
import CollectorsRowHeading from '../Collectors/CollectorsRowHeading'
import HeaderArea from '../HeaderArea'

function FullTopArtists() {
    return (
        <div className="TopCollectors">
            <HeaderArea
            title = "Top Artists"
           />
            <div className="dataTable">
                <table>
                    <CollectorsRowHeading
                        Collector = "Top Artist"
                        WorksCollected = "Works Created"
                        WorksOwned = "Works Sold"
                        AvgPurchasePrice = "Avg. Sale Price"
                        TotalPurchases = "Total Sales"
                        BiggestPurchase =  "Higest Sale"
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksCollected = {19}
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                </table>
            </div>
        </div>
    )
}

export default FullTopArtists
